// extracted by mini-css-extract-plugin
module.exports = {"ContactMe":"ContactMe_ContactMe__27Ook","anim":"ContactMe_anim__3Oa6T","Content":"ContactMe_Content___3Kcl"};